import React from 'react';
import { FullcalendarEvent } from '@pixel-kraft/commulino-types';
import { Container } from 'components';
import moment from 'moment';
import useWindowDimensions from 'lib/useWindowDimensions';
import styles from './jubilaeum.module.css';

type t_props = {
  events: FullcalendarEvent[][],
  id: string
}

const parseEntry = (event: FullcalendarEvent) => {
  const description = `${event.extendedProps.description ?? ''}`.trim();
  const years = description.match(/^\s*(\d{1,3})\b/)?.[1];
  return {
    name: event.title.trim() || 'Unbekannt',
    years
  };
};

const Jubilaeum = ({
  events,
  id
}: t_props) => {
  const renderEntry = (event: FullcalendarEvent) => {
    const parsed = parseEntry(event);
    return (
      <div className={styles.entry} key={event.id}>
        {event.extendedProps.image && <img className={styles.image} alt='404' src={event.extendedProps.image} />}
        <div className={styles.textBlock}>
          <div className={styles.preTitle}>wir gratulieren</div>
          <div className={styles.name}>{parsed.name}</div>
          <div className={styles.preYears}>zum</div>
          <div className={styles.years}>{parsed.years ?? '-'}</div>
          <div className={styles.postYears}>jährigen Dienstjubiläum</div>
        </div>
      </div>
    );
  };

  const {
    width,
    height
  } = useWindowDimensions();

  const noContent = events[0].length === 0;
  const image = `${process.env.PUBLIC_URL}/images/backgrounds/jubilaeum-${width > height ? 'quer' : 'hoch'}.jpg`;

  return (
    <Container
      id={id}
      image={image}
    >
      {noContent ? (
        <p className={styles.soonDate}>Am {moment().format('D. MMMM')} kein Jubiläum.</p>
      ) : (
        <div className={styles.todayEntries}>
          {events[0].map(renderEntry)}
        </div>
      )}
    </Container>
  );
};

export default Jubilaeum;
